/**
 * BLK6: PDP Accordion — smooth open/close animation
 * <details> のネイティブ挙動を活かしつつ、Web Animations API でヌルっと開閉。
 * 排他制御なし（複数パネル同時展開OK）。
 */
(function () {
  const DURATION = 300;
  const EASING = 'ease';

  document.querySelectorAll('.pdp-accordion__panel').forEach((details) => {
    const summary = details.querySelector('.pdp-accordion__header');
    const body = details.querySelector('.pdp-accordion__body');
    if (!summary || !body) return;

    let animation = null;
    let isClosing = false;
    let isExpanding = false;

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      details.style.overflow = 'hidden';

      if (isClosing || !details.open) {
        open();
      } else if (isExpanding || details.open) {
        close();
      }
    });

    function open() {
      details.style.height = `${details.offsetHeight}px`;
      details.open = true;
      window.requestAnimationFrame(() => {
        isExpanding = true;
        const startHeight = details.offsetHeight;
        const endHeight = summary.offsetHeight + body.scrollHeight;

        if (animation) animation.cancel();

        animation = details.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: DURATION, easing: EASING }
        );
        animation.onfinish = () => onAnimationFinish(true);
        animation.oncancel = () => { isExpanding = false; };
      });
    }

    function close() {
      isClosing = true;
      const startHeight = details.offsetHeight;
      const endHeight = summary.offsetHeight;

      if (animation) animation.cancel();

      animation = details.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        { duration: DURATION, easing: EASING }
      );
      animation.onfinish = () => onAnimationFinish(false);
      animation.oncancel = () => { isClosing = false; };
    }

    function onAnimationFinish(open) {
      details.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }
  });
})();
